export default {
  namespaced: true,
};
